import { getAxiosInstance } from "../ApiConfig";

const LoginToken = localStorage.getItem('cx_token');
const headers = {};
headers.Authorization = `Bearer ${LoginToken}`;

async function FetchAllQuotes(page,limit) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/fetchAllQuotesByReportingRoleUsers${page ? `?page=${page}&limit=${limit}` : ''}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function getCompanyQuotes() {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findAllQuotesByCompany`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function FetchQuoteDetails(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/findOneByQuotes/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function FetchQuotesByDeal(id) {
    try {
        const response = await getAxiosInstance().get(`/usermgmt/getAllQuotesByDealId/${id}`, { headers });
        return response.data
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function deleteQuotes(id) {
    try {
        const data = await getAxiosInstance().delete(`/usermgmt/deleteQuotes/${id}`, { headers });
        return data
    } catch (err) {
        throw err.response.data.message.message;
    }
}
async function createQuotes(payload) {
    try {
        const response = await getAxiosInstance().post(`/usermgmt/createQuotes`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
async function updateQuotes(payload, id) {
    try {
        const response = await getAxiosInstance().put(`/usermgmt/updateQuotes/${id}`, payload, { headers });
        return response;
    } catch (err) {
        throw err.response.data.message.message;
    }
};
export {
    createQuotes,
    updateQuotes,
    FetchAllQuotes,
    getCompanyQuotes,
    FetchQuoteDetails,
    FetchQuotesByDeal,
    deleteQuotes,
}